import { c as _c } from "react/compiler-runtime";
// Top chrome row for OG shells — wordmark + `morfi.markets` attribution.
// Layout mirrors the Figma Shell component (node 473:415).

import type { ShellHeaderLayout } from '../shell-tokens';
import { OgFooter } from './og-footer';
import { OgLogo } from './og-logo';
const WORDMARK_ASPECT_RATIO: number = 679 / 223;
const ATTRIBUTION_SLOT_WIDTH: number = 220;
interface OgHeaderChromeProps {
  layout: ShellHeaderLayout;
  logoSize: number;
  eyebrow: string | null;
}
export function OgHeaderChrome(props) {
  const $ = _c(33);
  let t0;
  if ($[0] !== props.logoSize) {
    t0 = Math.round(props.logoSize * WORDMARK_ASPECT_RATIO);
    $[0] = props.logoSize;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const logoWidth = t0;
  if (props.layout === "centered") {
    let t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        flexShrink: 0,
        position: "relative",
        zIndex: 1
      };
      t2 = <div style={{
        display: "flex",
        width: ATTRIBUTION_SLOT_WIDTH,
        flexShrink: 0
      }} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t1 = $[2];
      t2 = $[3];
    }
    let t3;
    if ($[4] !== props.logoSize) {
      t3 = <OgLogo size={props.logoSize} />;
      $[4] = props.logoSize;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        display: "flex",
        width: ATTRIBUTION_SLOT_WIDTH,
        flexShrink: 0,
        justifyContent: "flex-end"
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== props.eyebrow) {
      t5 = <div style={t4}><OgFooter eyebrow={props.eyebrow} /></div>;
      $[7] = props.eyebrow;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
      t6 = <div style={t1}>{t2}{t3}{t5}</div>;
      $[9] = t3;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  if (props.layout === "inline") {
    let t1;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        flexShrink: 0,
        position: "relative",
        zIndex: 1
      };
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    let t2;
    if ($[13] !== props.logoSize) {
      t2 = <OgLogo size={props.logoSize} />;
      $[13] = props.logoSize;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    let t3;
    if ($[15] !== props.eyebrow) {
      t3 = <OgFooter eyebrow={props.eyebrow} />;
      $[15] = props.eyebrow;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[17] !== t2 || $[18] !== t3) {
      t4 = <div style={t1}>{t2}{t3}</div>;
      $[17] = t2;
      $[18] = t3;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    return t4;
  }
  let t1;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      flexShrink: 0,
      position: "relative",
      zIndex: 1
    };
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== logoWidth) {
    t2 = {
      display: "flex",
      width: logoWidth,
      flexShrink: 0
    };
    $[21] = logoWidth;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] !== props.logoSize) {
    t3 = <OgLogo size={props.logoSize} />;
    $[23] = props.logoSize;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== t2 || $[26] !== t3) {
    t4 = <div style={t2}>{t3}</div>;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== props.eyebrow) {
    t5 = <OgFooter eyebrow={props.eyebrow} />;
    $[28] = props.eyebrow;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== t4 || $[31] !== t5) {
    t6 = <div style={t1}>{t4}{t5}</div>;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  return t6;
}